<template>
    <div class="home-main">
        <multi-children-vertical-menu
                v-if="!isSideMenuHide"
                :menus="menus"
                @click="onClickMenu"
                @setSideMenuHide="setSideMenuHide"
                @movePageMain="movePageMain"
        >
            <template #header>
                <!-- 사이드 메뉴 헤더 -->
                <navigation-side-header :user-name="userManager.userName" />
            </template>

            <template #footer>
                <navigation-side-footer />
            </template>
        </multi-children-vertical-menu>
        <multi-children-vertical-menu-mini
                v-else
                :menus="menus"
                :width="'50px'"
                @click="onClickMenu"
                @setSideMenuHide="setSideMenuHide"
        />

        <div :class="isMobile ? 'mobile-main-view' : 'main-view'">
            <keep-alive include="Dashboard,CompanyRank">
                <router-view />
            </keep-alive>
        </div>
    </div>
</template>

<script>
    import {navigation} from "../../constants";
    import MultiChildrenVerticalMenu from "@/components/common/menu/MultiChildrenVerticalMenu";
    import NavigationSideHeader from "@/components/menu/NavigationSideHeader";
    import NavigationSideFooter from "@/components/menu/NavigationSideFooter";
    import MultiChildrenVerticalMenuMini from "@/components/common/menu/MultiChildrenVerticalMenuMini";

    export default {
        name: "HomeMain",
        components: {
            NavigationSideFooter,
            NavigationSideHeader,
            MultiChildrenVerticalMenu,
            MultiChildrenVerticalMenuMini
        },
        data() {
            return {
                menus: navigation.SIDE_MENU,
                currentMenu: {},
                isSideMenuHide: false,
                isMobile: false,
            }
        },
        watch: {
            isMobile(v){
                if(v === true){
                    this.isSideMenuHide = true;
                }
            }
        },
        created() {
            this.checkMobile();
        },
        methods: {
            onClickMenu(menu) {
                if (!menu.id) return;
                this.currentMenu = menu;
                this.routerManager.replace({name: menu.id});
            },
            /**
             * 로고를 클릭시 메뉴를 접는 부분을 구현한것같습니다.
             * 메뉴를 접을시 Css 가 깨지는 부분은 차후에 보안해야될것 같습니다.
             */
            setSideMenuHide(){
                this.isSideMenuHide = !this.isSideMenuHide;
            },
            checkMobile() {
                this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                console.log('!!!!!!!!!!! t', this.isMobile);
            },
            /**
             * 로고 클릭시 홈으로 이동하기위해 구현했습니다.
             * 필요할것같아서 함수만 구현했습니다.
             *
             */
            movePageMain() {
                this.$router.push('/home/main/managertnbox/dashboard')
            }
        }
    }
</script>

<style scoped>
    .home-main {
        width: 100%;
        height: 100vh;
        display: flex;
        flex-direction: row;
        justify-content: stretch;
        overflow-x: auto;
        min-height: 900px;
        overflow-y: auto;
    }

    .main-view {
        flex-grow: 1;
        padding: 10px 20px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: hidden;

        background-color:#F9FCFF
    }

    .mobile-main-view {
        flex-grow: 1;
        padding: 3px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: hidden;
        min-width: 200px;
        background-color:#F9FCFF
    }
</style>